import { BreakpointObserver } from '@angular/cdk/layout';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { EvaluationEmployeeNineGrid } from '@qaroni-shared/types/evaluation-employee-nine-grid';

@Component({
  selector: 'qaroni-matrix-nine-grid',
  templateUrl: './matrix-nine-grid.component.html',
  styleUrl: './matrix-nine-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MatrixNineGridComponent {
  public readonly assessmentID = input<number>(0);
  public readonly companyID = input<number>(0);
  public readonly employees = input<EvaluationEmployeeNineGrid[]>([]);

  private breakpointObserver = inject(BreakpointObserver);

  get employeesHighPotentialLowPerformance() {
    return this.filterEmployees(this.isHighScore, this.isLowScore);
  }

  get employeesHighPotentialMediumPerformance() {
    return this.filterEmployees(this.isHighScore, this.isMediumScore);
  }

  get employeesHighPotentialHighPerformance() {
    return this.filterEmployees(this.isHighScore, this.isHighScore);
  }

  get employeesMediumPotentialLowPerformance() {
    return this.filterEmployees(this.isMediumScore, this.isLowScore);
  }

  get employeesMediumPotentialMediumPerformance() {
    return this.filterEmployees(this.isMediumScore, this.isMediumScore);
  }

  get employeesMediumPotentialHighPerformance() {
    return this.filterEmployees(this.isMediumScore, this.isHighScore);
  }

  get employeesLowPotentialLowPerformance() {
    return this.filterEmployees(this.isLowScore, this.isLowScore);
  }

  get employeesLowPotentialMediumPerformance() {
    return this.filterEmployees(this.isLowScore, this.isMediumScore);
  }

  get employeesLowPotentialHighPerformance() {
    return this.filterEmployees(this.isLowScore, this.isHighScore);
  }

  private filterEmployees(
    potentialFilter: (value: number) => boolean,
    performanceFilter: (value: number) => boolean
  ): EvaluationEmployeeNineGrid[] {
    const employees = this.employees();
    if (!Array.isArray(employees) || employees.length === 0) {
      return [];
    }

    return employees.filter(employee => {
      const potentialScore = employee.potentialScore
        ? Number(employee.potentialScore)
        : 0;
      const performanceScore = employee.scorePerformance
        ? Number(employee.scorePerformance)
        : 0;

      return (
        potentialFilter(potentialScore) && performanceFilter(performanceScore)
      );
    });
  }

  public isHighScore(value: number): boolean {
    return value > 66.6 && value <= 100;
  }

  public isMediumScore(value: number): boolean {
    return value > 33.3 && value <= 66.6;
  }

  public isLowScore(value: number): boolean {
    return !value || (value >= 0 && value <= 33.3);
  }
}
